import moment from 'moment';
import React from 'react';

import styles from './PickupTimelineItem.module.scss';

export interface PickupTimelineStepProps {
  iconUrl: string;
  title: string;
  description: string;
  time: string;
}

export const PickupTimelineStep: React.FC<PickupTimelineStepProps> = ({
  title,
  description,
  time,
  iconUrl,
}) => (
  <div className={styles['timeline-item-layout']}>
    <div className={styles['left-column']}>
      <img src={iconUrl} alt="icon" className={styles['tl-icon']} />
    </div>

    <div className={styles['pickup-timeline-item']}>
      <div className={styles.headline}>
        <div className={styles['item-title']}>{title}</div>
        <div className={styles['time-display']}>{moment(time).format('HH:mm')}</div>
      </div>

      <p className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  </div>
);
